<template>
  <section>
    <b-modal
      :active.sync="isActive"
      has-modal-card
      trap-focus
      aria-role="dialog"
      aria-modal
    >
      <div class="modal-card" style="width: 400px">
        <header class="modal-card-head">
          <p class="modal-card-title">Contact Us</p>
        </header>
        <section class="modal-card-body">
          <div v-if="form.visible">
            <b-field
              :label="$t('con.contact.name')"
              :type="form.name.status"
              :message="form.name.message"
            >
              <b-input
                v-model="form.name.data"
                :placeholder="$t('con.placeholder.name')"
                required
              ></b-input>
            </b-field>
            <b-field
              :label="$t('con.contact.email')"
              :type="form.email.status"
              :message="form.email.message"
            >
              <b-input
                type="email"
                v-model="form.email.data"
                :placeholder="$t('con.placeholder.email')"
                required
              ></b-input>
            </b-field>
            <b-field
              :label="$t('con.contact.phone')"
              :type="form.phone.status"
              :message="form.phone.message"
            >
              <b-input
                v-model="form.phone.data"
                :placeholder="$t('con.placeholder.phone')"
                required
              ></b-input>
            </b-field>
            <b-field
              :label="$t('con.contact.message')"
              :type="form.text.status"
              :message="form.text.message"
              expanded
            >
              <b-input
                maxlength="500"
                type="textarea"
                v-model="form.text.data"
                :placeholder="$t('con.placeholder.message')"
              ></b-input>
            </b-field>
            <b-field
              :label="$t('con.contact.human')"
              :type="form.human.status"
              :message="form.human.message"
            >
              <b-select
                v-model="form.human.data"
                :placeholder="$t('con.contact.human.op0')"
                expanded
              >
                <option value="1">{{$t("con.contact.human.op1")}}</option>
                <option value="2">{{$t("con.contact.human.op2")}}</option>
                <option value="3">{{$t("con.contact.human.op3")}}</option>
                <option value="4">{{$t("con.contact.human.op4")}}</option>
                <option value="5">{{$t("con.contact.human.op5")}}</option>
              </b-select>
            </b-field>
          </div>

          <div class="content responce">
            <b-message :type="form.status" v-if="form.result">
              {{ form.message }}
            </b-message>
          </div>
        </section>
        <footer class="modal-card-foot">
          <b-button type="is-dark" @click="close()">
            {{$t("btn.cancel")}}
          </b-button>
          <b-button
            v-if="form.visible"
            type="is-primary"
            @click="sendMessage()"
          >
          {{$t("btn.send")}}
          </b-button>
          <b-button
            v-if="!form.visible"
            type="is-primary"
            @click="resetForm()"
          >
          {{$t("btn.send.another")}}
          </b-button>
        </footer>
      </div>
    </b-modal>
  </section>
</template>

<script>
export default {
  name: "Contact",
  props: {
    email: String
  },
  data() {
    return {
      token: null,
      form: {
        email: {
          data: "",
          status: null,
          message: null
        },
        name: {
          data: "",
          status: null,
          message: null
        },
        phone: {
          data: "",
          status: null,
          message: null
        },
        text: {
          data: "",
          status: null,
          message: null
        },
        human: {
          data: null,
          status: null,
          message: null
        },
        visible: true,
        message: null,
        result: false,
        status: null
      }
    };
  },
  methods: {
    getToken: function() {
        this.axios
          .post("libs/token.php", {
            action: "getToken"
          })
          .then(response => {
            //this.isLoading = false;  
            console.log(response.data);        
            if (response.data.success) {
              this.token = response.data.token; 
            }
          })
          .catch(error => {
            //this.isLoading = false;
            console.log(error);
          });
      //end post-------------------------------------------------
    },
    sendMessage() {
      if (
        this.emailCheck("email") &
        this.formCheck("name") &
        this.formCheck("phone") &
        this.formCheck("text") &
        this.humanCheck("human")
      ) {

        this.axios
          .post("contact.php", {
            token: this.token,
            formData: {
              name: this.form.name.data,
              email: this.form.email.data,
              phone: this.form.phone.data,
              message: this.form.text.data
            }
          })
          .then(response => {
            //this.isLoading = false;  
            console.log(response.data);  
            
            if (response.data.success) {
              this.form.visible = false;
              this.form.status = "is-success";
              this.form.result = true;
              this.form.message = "Message Sent.";
            } else {
              this.form.status = "is-danger";
              this.form.result = false;
              this.form.message = response.data.message;
            }
          })
          .catch(error => {
            //this.isLoading = false;
            console.log(error);
            this.form.status = "is-danger";
            this.form.result = false;
            this.form.message = "An error occurred while sending the message.";
          });
      //end post-------------------------------------------------
      } else {
        this.form.status = "is-danger";
        this.form.result = true;
        this.form.message = "Ooops! Something went wrong. Please try again.";
      }
    },
    emailCheck(e) {
      let re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/; //eslint-disable-line
      if (!this.form[e].data || !re.test(this.form[e].data)) {
        this.form[e].status = "is-danger";
        this.form[e].message = "Please enter a valid email address";
        return false;
      } else {
        this.form[e].message = null;
        this.form[e].status = "is-success";
        return true;
      }
    },
    formCheck(e) {
      if (!this.form[e].data) {
        this.form[e].status = "is-danger";
        this.form[e].message = "Please fill out all required fields";
        return false;
      } else {
        this.form[e].status = "is-success";
        return true;
      }
    },
    itemCheck(e) {
      if (!this.item[e].data) {
        this.item[e].status = "is-danger";
        this.item[e].message = "Please fill out all required fields";
        return false;
      } else {
        this.item[e].status = "is-success";
        this.item[e].message = "";
        return true;
      }
    },
    humanCheck(e) {
      if (this.form[e].data == 4) {
        this.form[e].status = "is-success";
        this.form[e].message = "Human, eh?";
        return true;
      } else {
        this.form[e].status = "is-danger";
        this.form[e].message = "You did not pass the human test.";
        return false;
      }
    },
    close() {
      this.$store.commit('hideModal', 'contact');
    },
    resetForm() {
      this.form.visible = true;
      this.form.status = "is-success";
      this.form.result = false;
      this.form.message = "";
      this.form.name.data = "";
      this.form.email.data = "";
      this.form.phone.data = "";
      this.form.text.data = "";
    }
  },
  mounted(){
    console.log("contact mounted");
    this.getToken();
  },
  computed: {
    isActive: {
      get: function() {
        return this.$store.state.modals.contact;
      },
      // setter
      set: function() {
        this.$store.commit('hideModal', 'contact');
        return false;
      }
    }
  }
};
</script>
<style scoped>
  .modal-card-foot {
    justify-content: space-between; /* flex-end; */
  }
  .responce{
    color: #181818!important;
  }
  
</style>
